import React from 'react';

import { CustomColumnsContainer as BaseColumnsContainer } from '../../../blockColumnsContainer';

import { ReaderBlock } from '../../Reader/core';

const ColumnsContainerReader = ({ style, props, fCode, cmCode, form_data, formClientWidth, unSubData,
  errorMessage,
  successMessage, ...rest })=> {
  const { columns, ...restProps } = props ?? {};
  let cols = undefined;
  if (columns) {
    cols = columns.map((col) => col.childrenIds.map((childId) => <ReaderBlock key={childId} id={childId} fCode={fCode} cmCode={cmCode} formData={form_data} 
      formClientWidth={formClientWidth}
      unSubData={unSubData} errorMessage={errorMessage} successMessage={successMessage}
      {...rest}
    />));
  }

  return <BaseColumnsContainer formClientWidth={formClientWidth} props={restProps} columns={cols} style={style} />;
}

export default ColumnsContainerReader
